/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  Derived,
  HubspotMetadata,
} from 'rpc-client-utils';

export type GetAvailableAppPermissionsForAppRequest = {
  /** @deprecated use getAppMetadataVisibilities() instead. */
  visibilities: Default<Visibility[]>;
  appMetadataVisibilities: Default<AppMetadataVisibility[]>;
  componentType?: string;
  appId?: number;
};

export type AppMetadataVisibility =
  | 'USER_LEVEL_ACCESS_AND_PUBLIC_DISTRIBUTION'
  | 'USER_LEVEL_ACCESS_AND_PRIVATE_DISTRIBUTION'
  | 'PORTAL_LEVEL_ACCESS_AND_PUBLIC_DISTRIBUTION'
  | 'PORTAL_LEVEL_ACCESS_AND_PRIVATE_DISTRIBUTION'
  | 'DEVELOPER'
  | 'APP_ALLOWLIST'
  | 'PORTAL_ALLOWLIST'
  | unhandledEnumCase;

export type AppPermissionAction =
  | 'READ'
  | 'WRITE'
  | 'VIEW'
  | 'CREATE'
  | 'EDIT'
  | 'MERGE'
  | 'DELETE'
  | 'PUBLISH'
  | unhandledEnumCase;

export type Cardinality = 'ALL_OF' | 'ANY_OF' | unhandledEnumCase;

export type DataClassification =
  | 'NORMAL'
  | 'CONDITIONALLY_SENSITIVE'
  | 'SENSITIVE'
  | 'HIGHLY_SENSITIVE'
  | unhandledEnumCase;

export type ModelType = 'SCOPES' | 'USER_PERMISSIONS' | unhandledEnumCase;

export type State =
  | 'READY'
  | 'PENDING'
  | 'WAITING_TRANSLATIONS'
  | 'WAITING_APPROVAL'
  | 'DEPRECATED'
  | unhandledEnumCase;

export type TranslationStatus =
  | 'ML_IN_PROGRESS'
  | 'ML_COMPLETED'
  | 'LINGUINE_IN_PROGRESS'
  | 'LINGUINE_COMPLETED'
  | unhandledEnumCase;

export type Visibility =
  | 'VISIBLE_DEVELOPER'
  | 'VISIBLE_PRIVATE_DISTRIBUTION'
  | 'VISIBLE_PUBLIC_DISTRIBUTION'
  | 'VISIBLE_USER_LEVEL_ACCESS_TYPE'
  | 'VISIBLE_PORTAL_LEVEL_ACCESS_TYPE'
  | 'APP_ALLOWLIST'
  | 'PORTAL_ALLOWLIST'
  | unhandledEnumCase;

export type AppPermissionChirp = {
  scopes?: string[];
  userPermissions?: string[];
  appMetadataVisibilities: Default<AppMetadataVisibility[]>;
  allowedComponentTypes: Default<Record<string, string[]>>;
  isSchema: Derived<boolean>;
  id: number;
  createdAt: Default<number>;
  updatedAt: Default<number>;
  name: string;
  /** @deprecated */
  family: string;
  icon?: string;
  shortDescription: string;
  longDescription: string;
  cardinality: Cardinality;
  dataClassification: DataClassification;
  state: State;
  /** @deprecated */
  visibility: Default<Visibility[]>;
  modelTypes: Default<ModelType[]>;
  ownerJanusTeam: string;
  ownerAppId?: number;
  resourceType?: string;
  resourceTypeId?: string;
  action?: AppPermissionAction;
  resourceSubType?: string;
  resourceTypeLabel?: string;
  /** @deprecated */
  translationStatus?: TranslationStatus;
  translationState: Default<TranslationStatus[]>;
  readOnly?: boolean;
};

export type AppPermissionGetError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type AppPermissionTranslationBatchRequest = {
  appPermissionNames: Default<string[]>;
  portalIdForTranslation?: number;
  userIdForTranslation?: number;
};

export type AppPermissionTranslationBatchResponse = {
  translations: Default<AppPermissionTranslationItem[]>;
};

export type AppPermissionTranslationItem = {
  appPermissionName: string;
  label?: string;
  description?: string;
};

export type GetAppPermissionsByResourceTypeRequest = {
  resourceType: string;
  resourceTypeId: string;
};

export type GetAppPermissionsByResourceTypeResponse = {
  appPermissions: Default<Record<string, AppPermissionChirp>>;
};

export type GetAvailableAppPermissionsResponse = {
  appPermissions: Default<Record<string, AppPermissionChirp>>;
};

export type ErrorType =
  | 'NOT_FOUND'
  | 'INTERNAL_ERROR'
  | 'ILLEGAL_ARGUMENT'
  | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetAvailableAppPermissionsReplicatedRequestType =
  Requestify<GetAvailableAppPermissionsForAppRequest>;
export type GetAvailableAppPermissionsReplicatedResponseType =
  GetAvailableAppPermissionsResponse;
export type GetAvailableAppPermissionsReplicatedErrorType =
  AppPermissionGetError & HubspotMetadata;
export const getAvailableAppPermissionsReplicatedRpc: ChirpAvroRpcDetails<
  GetAvailableAppPermissionsReplicatedRequestType,
  GetAvailableAppPermissionsReplicatedResponseType,
  GetAvailableAppPermissionsReplicatedErrorType,
  false
> = {
  serviceName:
    'com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc',
  rpcName: 'getAvailableAppPermissionsReplicated',
  auth: 'app',
  fingerprint: 'q4BOJMoHzQK2sOLeiU1QTgxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppPermissionsByResourceTypeReplicatedRequestType =
  Requestify<GetAppPermissionsByResourceTypeRequest>;
export type GetAppPermissionsByResourceTypeReplicatedResponseType =
  GetAppPermissionsByResourceTypeResponse;
export type GetAppPermissionsByResourceTypeReplicatedErrorType =
  AppPermissionGetError & HubspotMetadata;
export const getAppPermissionsByResourceTypeReplicatedRpc: ChirpAvroRpcDetails<
  GetAppPermissionsByResourceTypeReplicatedRequestType,
  GetAppPermissionsByResourceTypeReplicatedResponseType,
  GetAppPermissionsByResourceTypeReplicatedErrorType,
  false
> = {
  serviceName:
    'com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc',
  rpcName: 'getAppPermissionsByResourceTypeReplicated',
  auth: 'app',
  fingerprint: 'z93cVXdb3KfspGLxqppkUQxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppPermissionTranslationsRequestType =
  Requestify<AppPermissionTranslationBatchRequest>;
export type GetAppPermissionTranslationsResponseType =
  AppPermissionTranslationBatchResponse;
export type GetAppPermissionTranslationsErrorType = AppPermissionGetError &
  HubspotMetadata;
export const getAppPermissionTranslationsRpc: ChirpAvroRpcDetails<
  GetAppPermissionTranslationsRequestType,
  GetAppPermissionTranslationsResponseType,
  GetAppPermissionTranslationsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.app.permissions.hublets.app.auth.rpc.AppPermissionsHubletsAppAuthRpc',
  rpcName: 'getAppPermissionTranslations',
  auth: 'app',
  fingerprint: 'KW3la1jaOsmCg8a8fHl1VgxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
